import { Koukyuu } from "@/types/Shinsei";
import { KoukyuuService } from "@/service/KoukyuuService"
import { DialogService } from "@/service/DialogService";
import { useForm } from '@/composable/form/form';
import { AxiosError } from "axios";
import { FormUtil } from "@/utils/FormUtil";
import router from "@/routers";
import { RouterConst } from "@/const/Router";

export function useCreate() {
  const srv = new KoukyuuService()
  const { removeAllError } = useForm()

  const create = async(params: Koukyuu) => {
    DialogService.nowloading('処理中...');

    const res = await srv.create(params).catch(e => {
      // 一回全部消す
      // removeAllError(params)
      removeAllError(params)

      const err = e as AxiosError<any>;
      FormUtil.setLaravelError(params, err);
    }).then(async(res) => {
      if (res) {
        await DialogService.info({
          text: `申請しました`
        }, true)
        router.push({ name: RouterConst.HOME })
      }
      return res
    })
    return res
  }

  return {
    create,
  }
}
